import { h } from 'hyperapp';
import './pagination.less';
import { PAGE_SIZE } from '../../constants';
import { getProductData } from '../../../pages/pdp/utils/data';
import { readPagination } from '../../../pages/pdp/utils/readPagination';

const SingleControl = ({ value, isCurrent, switchTo, setPage }) =>
    isCurrent ? (
        <span class="pagination__control pagination__control_current">{value}</span>
    ) : (
        <a
            href="#"
            onclick={event => {
                event.preventDefault();
                setPage(switchTo);
            }}
            class="pagination__control"
        >
            {value}
        </a>
    );

const PaginationControls = ({
    index,
    lastPage,
    showLeftArrow,
    showRightArrow,
    showLeftEllipsis,
    showRightEllipsis,
    sector,
    setPage,
}) => (
    <div>
        {showLeftArrow && <SingleControl setPage={setPage} value="<" switchTo={index - 1} />}
        <SingleControl setPage={setPage} value={1} isCurrent={index === 1} switchTo={1} />
        {showLeftEllipsis && '...'}
        {sector.map((item, orderNumber) => (
            <SingleControl
                setPage={setPage}
                key={`sector-${orderNumber}`}
                value={item}
                isCurrent={index === item}
                switchTo={item}
            />
        ))}
        {showRightEllipsis && '...'}
        {lastPage > 1 && (
            <SingleControl
                setPage={setPage}
                value={lastPage}
                isCurrent={index === lastPage}
                switchTo={lastPage}
            />
        )}
        {showRightArrow && <SingleControl setPage={setPage} value=">" switchTo={index + 1} />}
    </div>
);

const PaginationControlsWrapper = ({ index, length, setPage }) => {
    const atFirstPages = index <= 3;
    const atLastPages = index > length - 3;
    const longPagination = length > 6;

    let initialSector = [];

    if (longPagination && !atFirstPages) {
        if (atLastPages) {
            initialSector = [length - 4, length - 3, length - 2, length - 1];
        } else {
            initialSector = [index - 2, index - 1, index, index + 1, index + 2];
        }
    } else {
        initialSector = [2, 3, 4, 5];
    }

    const sector = initialSector.filter(item => item > 1 && item < length);
    const showLeftEllipsis = longPagination && index > 4;
    const showRightEllipsis = longPagination && length - index > 3;

    return (
        <PaginationControls
            index={index}
            lastPage={length}
            showLeftArrow={index > 1}
            showRightArrow={index < length}
            showLeftEllipsis={showLeftEllipsis}
            showRightEllipsis={showRightEllipsis}
            sector={sector}
            setPage={setPage}
        />
    );
};

export const Pagination = ({ items, pageNumber, setPage }) => {
    const pagesAmount = Math.ceil(items.length / PAGE_SIZE);
    const firstItem = PAGE_SIZE * (pageNumber - 1) + 1;
    const defaultLastItem = PAGE_SIZE * pageNumber;
    const lastItem = defaultLastItem > items.length ? items.length : defaultLastItem;
    const productData = getProductData();
    return (
        <div class="pagination">
            <div class="pagination__text">
                {readPagination(productData.paginationTemplate, {
                    first: firstItem,
                    last: lastItem,
                    total: items.length,
                })}
            </div>
            <div class="pagination__controls">
                <PaginationControlsWrapper
                    index={pageNumber}
                    length={pagesAmount}
                    setPage={setPage}
                />
            </div>
        </div>
    );
};
